import type { ReactNode } from 'react'
import { useLocation } from 'react-router'
import type { InterpolationFunction } from 'styled-components'
import styled from 'styled-components'

import user from 'legacy/utils/user'

import RateCommandCenterHeader from 'rate-command-center/ui/RateCommandCenterHeader'

import LoggedInNavigation from './LoggedInNavigation'
import LoggedOutNavigation from './LoggedOutNavigation'

interface PageWithSideNavProps {
  readonly children: ReactNode
  readonly color?: string
  readonly padding?: string | InterpolationFunction<any>
}

const Wrapper = styled.div`
  m-page-content > m-header {
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
  }
`

const MAGIC_LINK_MIGRATED_PATHS = ['/all-in-one']

function ShipperGuideLayout({ children, color, padding }: PageWithSideNavProps) {
  const { pathname } = useLocation()

  const renderSideAndTopNavigationForLoggedOutUser =
    user.isLoggedIn() === false && MAGIC_LINK_MIGRATED_PATHS.includes(pathname)

  if (renderSideAndTopNavigationForLoggedOutUser) {
    return (
      <LoggedOutNavigation color={color} padding={padding}>
        {children}
      </LoggedOutNavigation>
    )
  }

  if (user.isLoggedIn()) {
    return (
      <LoggedInNavigation color={color} padding={padding}>
        {children}
      </LoggedInNavigation>
    )
  }

  return (
    <>
      <RateCommandCenterHeader showAllInfo={false} />
      <Wrapper>{children}</Wrapper>
    </>
  )
}

export default ShipperGuideLayout
